<div #inputContainer class="input-container {{ customClass }}" [class.disabled]="isDisabled">
  <div class="input-group">
    <div class="input-group-text" *ngIf="icon">
      <gray-icon [icon]="icon"></gray-icon>
    </div>

    <input
      type="text"
      class="form-control fs-large"
      autocapitalize="off"
      autocomplete="off"
      [disabled]="isDisabled"
      [value]="value"
      [placeholder]="placeholder"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"
      (focusin)="inputContainer.classList.add('active')"
      (focusout)="inputContainer.classList.remove('active')"
    />

    <!-- Loading spinner (sağ taraf) -->
    <div class="input-group-text" *ngIf="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>
  </div>
</div>
